import { V2VOptionsEnabled } from '@varo/graphql-schema-types';
import { NativeStackHeaderProps, Stack, useRouter } from 'expo-router';
import { StatusBar } from 'expo-status-bar';
import DetourV2a from 'features/v2a/sender/components/DetourV2a/DetourV2a';
import useV2AOptions from 'features/v2a/sender/hooks/useV2AOptions';
import EducationScreen from 'features/v2a/sender/screens/EducationScreen/EducationScreen';
import React, { useEffect, useState } from 'react';
import { StyleSheet, View } from 'react-native';
import FullScreenLoading from 'shared/components/vxl/loading/FullScreenLoading/FullScreenLoading';
import LoadingSpinner from 'shared/components/vxl/loading/LoadingSpinner/LoadingSpinner';
import ExpoNavigationBar from 'shared/components/vxl/navigation/ExpoNavigationBar/ExpoNavigationBar';
import { isWeb } from 'shared/constants/platform';
import { navigateBack } from 'shared/helpers/backNavigation.helpers';
import { useStatsig } from 'shared/hooks/statsig/useStatsig';
import ErrorScreen from 'shared/patterns/vxl/errors/ErrorScreen/ErrorScreen';
import ScreenTransitionOverlay from 'shared/patterns/vxl/ScreenTransitionOverlay/ScreenTransitionOverlay';
import { FeatureFlagKey } from 'shared/providers/statsig/StatsigProvider.d';
import theme from 'shared/styles/theme';

const V2aScreen = () => {
  const router = useRouter();
  const {
    errorModel,
    fetching,
    isFirstTime,
    isV2ADisabled,
    v2vOptions,
    isV2ABlocked,
  } = useV2AOptions();
  const screenContent = (v2vOptions as V2VOptionsEnabled)?.educationalScreenV2;

  const { isFeatureEnabled } = useStatsig();

  const [isDataLoaded, setIsDataLoaded] = useState(false);
  useEffect(() => {
    if (!fetching && v2vOptions) {
      setIsDataLoaded(true);
    }
  }, [fetching, v2vOptions]);

  const isV2AWebSenderFlowEnabled = isFeatureEnabled(
    FeatureFlagKey.V2A_WEB_SENDER_FLOW,
  );
  const isV2ASupportedOnDevice =
    (isV2AWebSenderFlowEnabled || !isWeb) && !isV2ABlocked;
  const showEducationScreen = isFirstTime;

  useEffect(() => {
    if (isV2ASupportedOnDevice && !showEducationScreen && isDataLoaded) {
      router.replace('/move-money/v2a/transfer');
    }
  }, [isV2ASupportedOnDevice, showEducationScreen, isDataLoaded, router]);

  return (
    <View style={styles.container}>
      <StatusBar style="dark" />
      <Stack.Screen
        options={{
          headerShown: true,
          headerTransparent: true,
          header: (props: NativeStackHeaderProps) => (
            <ExpoNavigationBar
              {...props}
              transparent={true}
              options={{ headerBackVisible: true }}
              primaryOnPress={() => navigateBack()}
            />
          ),
        }}
      />
      {!isDataLoaded && !isWeb ? (
        <View style={styles.loaderStyle}>
          <FullScreenLoading isCoinLoader titleText="" bodyText="" />
        </View>
      ) : null}
      {isV2ASupportedOnDevice ? (
        <View style={styles.educationScreenContainer}>
          {isFirstTime ? (
            <EducationScreen screenContent={screenContent} />
          ) : null}
        </View>
      ) : (
        <DetourV2a />
      )}
      <ScreenTransitionOverlay
        isLoading={false}
        LoadingComponent={<LoadingSpinner />}
        ErrorComponent={
          isV2ADisabled && errorModel && !fetching ? (
            <ErrorScreen {...errorModel} />
          ) : null
        }
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: theme.color.background.primary,
    flex: 1,
  },
  educationScreenContainer: {
    flex: 1,
  },
  loaderStyle: {
    flex: 1,
  },
});

export default V2aScreen;
